"use client";

import { c as _c } from "react/compiler-runtime";
import { IMaskInput } from "react-imask";
import { extractLocalDigits, formatPhoneInput } from "@/shared/auth/phone";
import { cn } from "@/shared/lib/utils";
import { InputGroup, InputGroupAddon } from "@/shared/ui/input-group";
type PhoneInputProps = {
  value: string;
  onValueChange: (formatted: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  id?: string;
  disabled?: boolean;
  "aria-invalid"?: boolean;
  placeholder?: string;
  className?: string;
};
function PhoneInput(t0) {
  const $ = _c(20);
  const {
    value,
    onValueChange,
    onBlur,
    name,
    id,
    disabled,
    "aria-invalid": ariaInvalid,
    placeholder: t1,
    className
  } = t0;
  const placeholder = t1 === undefined ? "90 123 45 67" : t1;
  let t2;
  if ($[0] !== value) {
    t2 = extractLocalDigits(value);
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const maskValue = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InputGroupAddon align="inline-start">+998</InputGroupAddon>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "0": /\d/
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onValueChange) {
    t5 = unmasked => {
      if (!unmasked) {
        onValueChange("");
        return;
      }
      onValueChange(formatPhoneInput(unmasked));
    };
    $[4] = onValueChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 aria-invalid:ring-0 dark:bg-transparent", "placeholder:text-muted-foreground h-9 w-full min-w-0 px-2.5 py-1 text-base outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm");
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== ariaInvalid || $[8] !== disabled || $[9] !== id || $[10] !== maskValue || $[11] !== name || $[12] !== onBlur || $[13] !== placeholder || $[14] !== t5) {
    t7 = <IMaskInput mask="00 000 00 00" definitions={t4} value={maskValue} unmask={true} onAccept={t5} id={id} name={name} type="tel" inputMode="numeric" autoComplete="tel-national" placeholder={placeholder} disabled={disabled} aria-invalid={ariaInvalid} onBlur={onBlur} data-slot="input-group-control" className={t6} />;
    $[7] = ariaInvalid;
    $[8] = disabled;
    $[9] = id;
    $[10] = maskValue;
    $[11] = name;
    $[12] = onBlur;
    $[13] = placeholder;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== className || $[17] !== disabled || $[18] !== t7) {
    t8 = <InputGroup className={className} data-disabled={disabled}>{t3}{t7}</InputGroup>;
    $[16] = className;
    $[17] = disabled;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
export { PhoneInput };